export default ( form, name ) => {
    if (!form) return ''
    if (!name) return ''
    const vals = form.getValues()
    if (!vals) return ''
    let val = vals[name]
    if (!val) return ''
    return val
}